/** Ported from haulsheet index.html ocrMerge / ocrPair. */
import { ocrBetterPlace, ocrClearFilledWarnings } from "./shared.js";
export function ocrMerge(a, b) {
    if (!b)
        return a;
    if (!a)
        return b;
    const labels = {
        linehaul: "Rate",
        miles: "Miles",
        deadhead: "Deadhead",
        weight: "Weight",
        length: "Length",
        width: "Width",
        height: "Height",
    };
    for (const k of Object.keys(labels)) {
        const x = String(a[k] || "").trim();
        const y = String(b[k] || "").trim();
        const label = labels[k];
        if (!x && y) {
            a[k] = y;
            a.unreadable = a.unreadable.filter((u) => u.indexOf(label + " reads as") !== 0 &&
                u.indexOf(label + " is blank") !== 0 &&
                !/^Posted rate could not be read/i.test(u));
            a.unreadable.push(label + " was read on the second try only (" + y + "): check it");
        }
        else if (x && y && x !== y) {
            a.unreadable.push(label + " read two ways, " + x + " and " + y + ". Using " + x + ": check it");
        }
    }
    for (const k of ["equipment", "commodity", "pickup", "delivery"]) {
        if (!String(a[k] || "").trim() && String(b[k] || "").trim())
            a[k] = b[k];
    }
    a.origin = ocrBetterPlace(a.origin, b.origin);
    a.destination = ocrBetterPlace(a.destination, b.destination);
    ocrClearFilledWarnings(a);
    return a;
}
export function ocrPair(primary, secondary) {
    const used = {};
    const out = primary.map((p) => {
        let best = -1;
        let bd = 1e9;
        secondary.forEach((s, i) => {
            const d = Math.abs((s._cy || 0) - (p._cy || 0));
            if (!used[i] && d < bd) {
                bd = d;
                best = i;
            }
        });
        if (best >= 0 && (bd < 25 || primary.length === 1)) {
            used[best] = true;
            return ocrMerge(p, secondary[best]);
        }
        return p;
    });
    secondary.forEach((s, i) => {
        if (!used[i] && !primary.length)
            out.push(s);
        else if (!used[i] &&
            primary.every((p) => Math.abs((p._cy || 0) - (s._cy || 0)) > 25)) {
            s.unreadable.push("This row was found on the second try only: check every field");
            out.push(s);
        }
    });
    return out;
}
//# sourceMappingURL=merge.js.map